import Image from 'next/legacy/image';
import { useRouter } from 'next/router';
import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useMinimalUserInteraction } from 'utils/hooks';
import { useLogImageLoadMutation, useLogImageClickMutation } from 'utils/hooks/mutations';

import css from './Styles.module.scss';

type ImageAdProps = {
  src: string;
  href: string;
  name: 'left' | 'right' | 'center' | 'banner';
};

const ImageAd: React.FC<ImageAdProps> = ({ src, href, name }) =>
{
  const loggingMutation = useLogImageLoadMutation();
  const clickLoggingMutation = useLogImageClickMutation();
  const router = useRouter();

  const mui = useMinimalUserInteraction();
  const { ref } = useInView({
    trackVisibility: true,
    delay: 100,
    triggerOnce: true,
    onChange: (inView) =>
    {
      if (inView && mui)
      {
        loggingMutation.mutate({ name });
      }
    },
  });

  const trackAndTransition = async () =>
  {
    clickLoggingMutation.mutate({ name });
    await router.push(href);
  };

  return (
    <a ref={ref} onClick={trackAndTransition} className={css.adImage}>
      <Image src={src} layout='fill' alt=""/>
    </a>
  );
};

export default ImageAd;